let timerId: number;

export function defferedTrack(cb: () => void, defferedTime: number = 10000) {
  const clearHandlers = () => {
    clearTimeout(timerId);

    document.removeEventListener('scroll', clearHandlers);
    document.removeEventListener('mousemove', clearHandlers);
    document.removeEventListener('touchstart', clearHandlers);
    document.removeEventListener('click', clearHandlers);
    document.removeEventListener('focus', clearHandlers);
  };

  document.addEventListener('scroll', clearHandlers);
  document.addEventListener('mousemove', clearHandlers, { capture: true });
  document.addEventListener('touchstart', clearHandlers, { capture: true });
  document.addEventListener('click', clearHandlers, { capture: true });
  document.addEventListener('focus', clearHandlers);

  timerId = window.setTimeout(() => {
    clearHandlers();
    cb();
  }, defferedTime);
}
